import { Theme } from '../../token/theme';

export const getTabContainerStyles = ({ showBottomLine, theme }: { showBottomLine: boolean; theme: Theme }) => {
	if (showBottomLine) {
		return {
			boxShadow: `inset 0px -1px ${theme.color.border.default}`
		}
	}
};
